const GARANTIAS_LONG_TEXT_MAX_LENGTH = 300

export const garantiasRows = [
    {
        key: "alienacao",
        label: "Alienação Fiduciária",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Descrever os ativos alienados fiduciariamente, caso tenha. Do contrário preencher 'Não tem'.",
        },
    },
    {
        key: "cessao",
        label: "Cessão Fiduciária",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Descrever os ativos cedidos fiduciariamente, caso tenha. Do contrário preencher 'Não tem'.",
        },
    },
    {
        key: "fiancaBancaria",
        label: "Fiança Bancária",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Informar o(s) banco(s) emissor(es) da(s) carta(s) fiança(s), caso tenha. Do contrário preencher 'Não tem'.",
        },
    },
    {
        key: "hipoteca",
        label: "Hipoteca",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Descrever os ativos hipotecados, caso tenha. Do contrário preencher 'Não tem'.",
        },
    },
    {
        key: "penhor",
        label: "Penhor",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Descrever os ativos dados em penhor, caso tenha. Do contrário preencher 'Não tem'.",
        },
    },
    {
        key: "avalista",
        label: "Avalista",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Descrever os principais avalistas da emissão, caso tenha. Do contrário preencher 'Não tem'.",
        },
    },
    {
        key: "fianca",
        label: "Fiança",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: "Não Tem",
        inputProps: {
            placeholder:
                "Descrever os principais fiadores da emissão, caso tenha. Do contrário preencher 'Não tem'.",
        },
    },

    { key: "mitigadorCreditoDivider", label: "MITIGADOR DE RISCO DE CRÉDITO", isDivider: true},

    { key: "fundoObra", label: "Fundo Obra", maxLength: 7, defaultValue: "Não Tem" },
    { key: "fundoReserva", label: "Fundo Reserva", maxLength: 7, defaultValue: "Não Tem" },
    { key: "fundoLiquidez", label: "Fundo Liquidez", maxLength: 7, defaultValue: "Não Tem" },
    { key: "seguro", label: "Seguro", maxLength: 7, defaultValue: "Não Tem" },

    { key: "dividerSeguroCotas", label: "", isLine: true },

    {
        key: "cotasInferiores",
        label: "Cotas Inferiores",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: null,
    },

    { key: "sobreGarantia", label: "Sobregarantia", maxLength: 7, defaultValue: "Não Tem" },

    {
        key: "patrimonioSeparado",
        label: "Patrimônio Separado",
        longText: true,
        maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
        defaultValue: null, 
    },
]

const buildGarantiaFields = () => {
    const fields = [
        {
            key: "tipoLastro",
            label: "Tipo Lastro",
            md: 9,
            type: "dynamicTextarea",
            longText: true,
            maxLength: GARANTIAS_LONG_TEXT_MAX_LENGTH,
            minRows: 2,
            maxRows: 5,
            defaultValue: null, 
        },
        {
            key: "contaVinculada",
            label: "Conta vinculada",
            md: 3,
            spacing: { mt: 0 },
            type: "radio",
            defaultValue: "nao",
            breakAfter: true
        },
    ]

    garantiasRows.forEach((row) => {
        if (row.isDivider) {
            fields.push({
                key: `${row.key}-divider`,
                label: row.label,
                type: "divider",
                md: 12,
                spacing: { mt: 2, mb: 2, ml: 0, mr: 0 },
            })
            return
        }

        if (row.isLine) {
            fields.push({
                key: `${row.key}-line`,
                type: "line",
                md: 12,
                spacing: { pt: 1, pb: 1, ml: 0, mr: 0 },
            })
            return
        }

        const longText = Boolean(row.longText)
        const checkKey = `${row.key}Check`
        const valueKey = `${row.key}Valor`

        fields.push(
            {
                key: checkKey,
                label: row.label,
                type: "checkbox",
                md: 1.5,
                ocr: false,
                spacing: { pl: 0, pt: 0, ml: 0 },
                clearOnFalse: [row.key, valueKey],
            },
            {
                key: row.key,
                label: row.label,
                md: 8.5,
                type: longText ? "dynamicTextarea" : undefined,
                longText,
                ocr: false,
                ocrMd: 6.5,
                maxLength: row.maxLength,
                minRows: longText ? 2 : undefined,
                maxRows: longText ? 5 : undefined,
                dependsOn: checkKey,
                disabledOutlineOnFalse: true,
                spacing: { pl: 0, ml: 0, mr: 0.75 },
                defaultValue: row.defaultValue ?? null,
                inputProps: row.inputProps,
            },
            {
                key: valueKey,
                label: "Valor",
                md: 2,
                ocrMd: 0,
                maskType: "decimal",
                dependsOn: checkKey,
                disabledOutlineOnFalse: true,
                spacing: { pl: 0, ml: 0 },
                breakAfter: true,
            }
        )
    })

    fields.push(
        { key: "ltvNumerador", label: "LTV Numerador", md: 4, maskType: "decimal" },
        { key: "ltvDenominador", label: "LTV Denominador", md: 4, maskType: "decimal" },
        { key: "ltv", label: "LTV", md: 4, maskType: "decimal", defaultValue: 100 } 
    )
    return fields
}

export const garantiasFields = buildGarantiaFields()
